import { render, staticRenderFns } from "./SessionScheduleBlock.vue?vue&type=template&id=2252746b&scoped=true"
import script from "./SessionScheduleBlock.vue?vue&type=script&lang=js"
export * from "./SessionScheduleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252746b",
  null
  
)

export default component.exports